module.exports = __webpack_public_path__ + "c7769c8a500f89b89836831e26d75fd3.svg";